import MigrateAlt16 from '@carbon/icons-react/es/migrate--alt/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectPhase } from 'api/project';
import { Menu } from 'components/atoms/dropdown';

const PhaseIcon = styled(MigrateAlt16)`
  color: var(--text-02);
`;

interface Props {
  phases?: ProjectPhase[];
  onClick: (phase: ProjectPhase) => void;
}

export const MoveTaskSubMenu: FC<Props> = ({
  phases = [],
  onClick,
  ...rest
}) => {
  return (
    <Menu.SubMenu
      {...rest} /* do not remove the rest, otherwise submenu won't work inside a Menu */
      key="move-task"
      icon={<MigrateAlt16 />}
      popupClassName="scrollable_submenu_for_phases"
      title={
        <span data-cy="task_more_options.move_task">
          <FormattedMessage id="task.move_to_phase" />
        </span>
      }
    >
      <Menu.Header className="sticky_menu_header">
        <FormattedMessage id="task.move_to_phase" />
      </Menu.Header>
      {phases.map((phase) => (
        <Menu.Item
          data-cy={`task_more_options.move_task.${phase.projectPhaseName}`}
          icon={<PhaseIcon />}
          key={phase.projectPhaseId}
          onClick={() => {
            onClick(phase);
          }}
          title={phase.projectPhaseName}
        >
          {phase.projectPhaseName}
        </Menu.Item>
      ))}
    </Menu.SubMenu>
  );
};
